import { HttpClient } from '../../httpClient'
import type {
  OpalApi,
  OpalApiResponseDocument,
  OpalApiRequestBody,
} from '../../schema'

type CreateRichTextDocumentV3 = OpalApi<'CreateRichTextDocumentV3', 201>

export type CreateRichTextDocumentV3ResponseData = OpalApiResponseDocument<
  'CreateRichTextDocumentV3',
  201
>

export type CreateRichTextDocumentV3RequestBody =
  OpalApiRequestBody<'CreateRichTextDocumentV3'>

export const createRichTextDocument: CreateRichTextDocumentV3 = async ({
  requestBody,
}: Parameters<CreateRichTextDocumentV3>[0] = {}) => {
  const url = new URL('/rich_texts/v3/documents', window.location.origin)

  return HttpClient()
    .post<CreateRichTextDocumentV3ResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
